import React from 'react'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import CharterBundleModalUspItem from './CharterBundleModalUspItem'
import LineClockTwoIcon from 'LuxKit/Icons/line/LineClockTwoIcon'
import LineSeatIcon from 'LuxKit/Icons/line/LineSeatIcon'
import LineLuxuryEscapesPlaneTailIcon from 'LuxKit/Icons/line/LineLuxuryEscapesPlaneTailIcon'

type CharterLearnMoreUsp = React.ComponentProps<typeof CharterBundleModalUspItem>

export const MaldivesUspGroup1: Array<CharterLearnMoreUsp> = [
  {
    title: 'Save up to 20 hours in transit*',
    description: 'No more international stopovers and waiting in airports, fly non-stop from Melbourne to Malé.',
    icon: <LinePlaneDepartureIcon />,
    tabletIcon: <LinePlaneDepartureIcon size="XL" />,
  },
  {
    title: 'Maximise your holiday time',
    description: 'Our overnight flights paired with early check-in & late checkout give you extra time to enjoy the Maldives.',
    icon: <LineClockTwoIcon />,
    tabletIcon: <LineClockTwoIcon size="XL" />
  }
]
export const MaldivesUspGroup2: Array<CharterLearnMoreUsp> = [
  {
    title: 'Strictly limited seats',
    description: 'Fewer than 300 seats available weekly across business, premium economy and economy.',
    icon: <LineSeatIcon />,
    tabletIcon: <LineSeatIcon size="XL" />,
  },
  {
    title: 'Luxury Escapes private charter',
    description: 'Enjoy a full-service Airbus A330-200, reserved exclusively for Luxury Escapes customers.',
    icon: <LineLuxuryEscapesPlaneTailIcon />,
    tabletIcon: <LineLuxuryEscapesPlaneTailIcon size="XL" />
  }
]
